export	default  {
    beneficiary_label: '开户单位：',
    beneficiary: '智奥会展（dfddddd深圳）有限公司',
    bank_label: '开户行：',
    bank: '中国银行深圳福田支行营业部',
    account_label: '银行账户：',
    account: '7458 7149 7819',
    pay_notice: '请您及时付款，以便订单尽快处理',
    download: '下载预租清单',
    order_num: '订单号：',
    unit: '元',
    tip_notice: '注意事项：汇款时需要注意以下信息，请牢记！',
    tip_pay_1: '1、请将待支付款项在',
    tip_pay_2: '到账周期一般为1-3个工作日。',
    tip_remit_1: '1、汇款金额请与应付金额保持一致，请勿多汇款或者少汇款,请您尽快汇清款项，逾期订单将自动取消。',
    tip_remit_2: '汇款时请将此识别码填写到汇款单 ',
    tip_remit_3: '【附言】',
    tip_remit_4: '栏内（仅填写此识别码） 。如未填写会影响订单确认时间。您的付款识别码已发送。',
    tip_num: '3、汇款金额请与应付金额保持一致，请勿多汇款或者少汇款。',
    tip_web_1: '4、汇款后5个工作日如果网站订单未更新为 "已支付" 状态请务必联系 ',
    tip_web_2: '，如 "未支付" 状态订单没有在规定上的时间内付款或者未联系我们将一律视为无效订单，我司将不负责任',
    tip_warm: '5、网上预租不会以订单无效、订单异常、系统升级等名义向您发送短信或者链接要求您提供银行卡以及验证码信息，请您加强防范意识，谨防受骗。',
    tip_order: '6、付款完成时，如您需要修改订单内容，请在订单中心取消该订单后重新下单。',
    tip_image: '汇款申请单填写示意图：为了您顺利的完成转账汇款，请在汇款用途一栏中正确的填写付款识别码',
    back: '返回订单中心',
    '请您尽快付款，以便订单及时处理':'请您尽快付款，以便订单及时处理',
    '联系人姓名':'联系人姓名',
    '联系电话':'联系电话',
    '支付方式':'支付方式',
    '应付金额':'应付金额',
    '汇款信息':'汇款信息',
    '汇款截止时间':'汇款截止时间',
    '汇款账号信息':'汇款账号信息',
    '汇款识别码':'付款识别码',
    '请将付款识别码填写到汇款单附言栏':'请将付款识别码填写到汇款单附言栏',
    '注意事项':'注意事项',
    '订单信息':'订单信息',
    '线下付款':'线下付款'
  }


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/feeOfflinePayment.js